export default __webpack_public_path__ + "static/media/muddy-bots.ea57fef9.svg";